<div *ngIf="remindersList?.length > 0">
    <section class="content scrolleable" style="width: 27vw; overflow-x: hidden;">
        <div class="card-item-reminders" *ngFor="let notification of remindersList">
            <div class="row">
                <div class="col-10 row pointer">
                    <div class="col-10">
                        <div class="col-12" *ngIf="notification.text == undefined">
                            <strong>{{ notification.reminder.reminderType.name }}</strong>
                        </div>
                        <div class="col-12" *ngIf="notification.text != undefined">
                            <p>{{ notification.text | localize }} - <strong>{{ notification.reminder.reminderType.name }}</strong></p>
                        </div>
                        <div class="col-12 d-flex align-items-center">
                            <p class="mb-0 flex-shrink-0">{{ timeSince(notification.creationTime) }}</p>
                        </div>
                    </div>
                </div>
                <div class="col-2 align-content-center">
                    <div class="w-100" style="text-align: right;">
                        <div class="tooltip-wrapper">
                            <i class="far fa-envelope pointer mr-2 option-item"
                                (mouseenter)="showTooltip(notification.id)"
                                (mouseleave)="hideTooltip(notification.id)"
                                (click)="setNotificationAsRead(notification.id)">
                            </i>
                            <span class="custom-tooltip" [class.visible]="tooltipsVisible[notification.id]">
                                {{ 'MarkAsRead' | localize }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <div class="show-all-reminder-button">
        <div class="row justify-content-center align-items-center">
            <div class="col-6 text-center border-right-custom">
                <p class="pointer" (click)="navigateToComponent()">
                    {{ "ShowAllNotifications" | localize }}
                </p>
            </div>
            <div class="col-6 text-center">
                <p class="pointer" (click)="create()">
                    {{ "Create" | localize }}
                </p>
            </div>
        </div>
    </div>
</div>
<div *ngIf="remindersList?.length == 0">
    <section class="content-header">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12 mt-1">
                    <i class="far fa-bell-slash mr-2"></i>
                    <span>{{ "DontHaveUnreadedReminders" | localize }}</span>
                </div>
            </div>
        </div>
    </section>
    <div class="show-all-reminder-button">
        <div class="row justify-content-center align-items-center">
            <div class="col-6 text-center border-right-custom">
                <p class="pointer" (click)="navigateToComponent()">
                    {{ "ShowAllNotifications" | localize }}
                </p>
            </div>
            <div class="col-6 text-center">
                <p class="pointer" (click)="create()">
                    {{ "Create" | localize }}
                </p>
            </div>
        </div>
    </div>
</div>